import { useEffect, useState } from 'react';
import axios from 'axios';
import { getSessionStorage, setSessionStorage } from '../components/utilities/functions';

export const useNearestLocation = () => {
	const [store, setStore] = useState({});
	const [status, setStatus] = useState('loading');

	useEffect(() => {
		if (getSessionStorage('NearestLowesStore') && getSessionStorage('NearestLowesStore').storeNumber) {
			setStore(getSessionStorage('NearestLowesStore'));
			setStatus('success');
		} else {
			axios
				.get(`${process.env.GATSBY_PELLA_API}/location/v2/lowes-store`)
				.then((res) => {
					if (res.data.name) {
						const data = {
							address: res.data.line_1,
							address2: res.data.line_2,
							city: res.data.city,
							state: res.data.state,
							postalCode: res.data.postal_code,
							storeNumber: res.data.store_number,
						};

						setSessionStorage('NearestLowesStore', data);
						setStore(data);
						setStatus('success');
					} else {
						setStore({ error: res.data?.error?.message });
						setStatus('error');
					}
				})
				.catch(() => setStatus('error'));
		}
	}, []);

	return { store, status };
};
